











import { defineComponent, onMounted } from '@vue/composition-api';

export default defineComponent({
  name: 'TabItem',
  components: {
  },
  props: {
    name: {
      type: String,
      defaut: '',
      required: true,
    },
    num: {
      default: 0,
      required: true,
    },
  },
  setup() {
    onMounted(async () => {
    });
    return {
    };
  },
});
